import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Voice } from "./Voice";

const RootLayout: React.FC = () => {
    const [selected, setSlected] = useState<string | undefined>()
    useEffect(() => {
        document.addEventListener("selectionchange", () => {
            setTimeout(() => setSlected(window.getSelection()?.toString()), 3000)
        });
        if (selected && new Voice().isActive()) {
            const speechSynthesis = window.speechSynthesis;
            const utterance = new SpeechSynthesisUtterance(selected || '');
            speechSynthesis.speak(utterance);
        }
        //  else if ('speechSynthesis'! in window) {
        //     console.error('Text-to-speech is not supported in your browser or element not found.');
        // }
    }, [selected]); // Empty dependency array ensures the effect runs once after the initial render

    return <>
        <Outlet />
    </>
}

export default RootLayout;